// Components Injection System (ES Module)

async function inject(selector, url) {
     const host = document.querySelector(selector);
     if (!host) return;

     // Skip injection if the component already has content (to preserve state)
     if (host.innerHTML.trim() !== '') {
          console.log('[components] Skipping injection for', selector, '- already has content');
          return;
     }

     // Additional check: if this is a floating component and the target element already exists in DOM
     if (selector.includes('floating-') && document.getElementById(selector.replace('[data-component="', '').replace('"]', ''))) {
          console.log('[components] Skipping injection for', selector, '- target element already exists in DOM');
          return;
     }

     try {
          const res = await fetch(url, { credentials: 'same-origin' });
          if (!res.ok) throw new Error('Failed to fetch ' + url);
          const html = await res.text();

          // Special handling for header: replace the container and handle mobile overlay
          if (selector === '[data-component="header"]') {
               // Extract and preserve the mobile overlay if it exists
               const existingOverlay = document.getElementById('mobile-menu');
               const overlayHtml = existingOverlay ? existingOverlay.outerHTML : '';

               host.outerHTML = html;

               // Re-insert the mobile overlay after the header if it was preserved
               if (overlayHtml) {
                    const header = document.querySelector('.site-header');
                    if (header) {
                         header.insertAdjacentHTML('afterend', overlayHtml);
                    }
               }
          } else {
               host.innerHTML = html;
          }
     } catch (err) {
          console.error('[components] inject error:', err);
     }
}

async function init() {
     // Header and footer are handled by simple-nav.js (no HTML component needed)
     // Theme switcher is handled by floating-theme-switcher.js (no HTML component needed)
     // Inventory is handled by floating-inventory.js (no HTML component needed)
     // Admin menu is handled by floating-admin-menu.js (no HTML component needed)
     
     // generic section injector: <div data-component="section:about"></div>
     const sectionMounts = document.querySelectorAll('[data-component^="section:"]');
     for (const mount of sectionMounts) {
          const name = (mount.getAttribute('data-component') || '').split(':')[1];
          if (!name) continue;
          await inject(`[data-component="section:${name}"]`, `/js/components/sections/${name}.html`);
     }
     
     if (window.SDGDR && typeof window.SDGDR.initNav === 'function') {
          window.SDGDR.initNav();
     } else if (typeof window.initSimpleNav === 'function') {
          window.initSimpleNav();
     }
}

if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', init);
} else {
     init();
}

export { inject, init };
